import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ToastNotification(props) {
    const { title = '', message = '' } = props;
    return (_jsxs("div", { children: [title && (_jsx("div", { children: _jsx("strong", { children: title }) })), message && _jsx("div", { children: message })] }));
}
